<template>
  <!--楼层弹窗-->
    <div class="floor">
      <div class="close"></div>
      <div class="floor-title">
        商务楼
      </div>
      <div class="box-list">
        <p>
          <span>占地面积 :</span>
          <span>{{item.area}}</span>
        </p>
        <p>
          <span>楼层数量 :</span>
          <span>{{item.layer}}</span>
        </p>
        <p>
          <span>大楼使用率 :</span>
          <span>100%</span>
        </p>
      </div>
    </div>
</template>

<script>
    export default {
        name: "FloorBox",
        props:['item']
    }
</script>

<style scoped lang="less">
  .floor{
    position: absolute;
    background: url("./../assets/tc1-box.png") no-repeat;
    background-size: 100% 100%;
    width: 203px;/*no*/
    height: 176px;/*no*/
    z-index: 999;
    .floor-title{
      position: absolute;
      background: url("./../assets/tc1-title.png") no-repeat;
      background-size: 100% 100%;
      width: 144px;/*no*/
      height: 29px;/*no*/
      top: 22px;/*no*/
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: "SourceHanSansCNVF";
      color: rgb(255, 255, 255);
      display: flex;
      align-items: center;
      justify-content: center;

    }
    .box-list{
      font-size: 14px;
      font-family: "Microsoft YaHei";
      color: rgb(255, 255, 255);
      position: absolute;
      top: 72px;/*no*/
      left: 32px;
      p{
        margin-bottom: 12px;
        span{
          &:nth-of-type(1){
            margin-right: 10px;
          }
        }
      }
    }
    .close{
      position: absolute;
      background: url("./../assets/close.png") no-repeat;
      background-size: 100% 100%;
      width: 10px;/*no*/
      height: 10px;/*no*/
      top: 10px;/*no*/
      right: 6px;/*no*/
      cursor: pointer;
    }
  }
</style>
